export type CancelTag = { key: string; label: string };

export const CANCEL_TAGS_REQUESTER: CancelTag[] = [
  { key: 'terms_changed',    label: 'Άλλαξαν οι όροι' },
  { key: 'personal_reasons', label: 'Προσωπικοί λόγοι' },
  { key: 'financial_reasons',label: 'Οικονομικοί λόγοι' },
  { key: 'no_response',      label: 'Αδυναμία επικοινωνίας' },
  { key: 'disagreement',     label: 'Διαφωνία' },
  { key: 'did_not_perform',  label: 'Δεν τήρησε τη συμφωνία' },
  { key: 'other',            label: 'Άλλο' },
];

export const CANCEL_TAGS_AGREE: CancelTag[] = [
  { key: 'mutual_agreement', label: 'Αμοιβαία απόφαση' },
  { key: 'terms_changed',    label: 'Άλλαξαν οι όροι' },
  { key: 'personal_reasons', label: 'Προσωπικοί λόγοι' },
  { key: 'financial_reasons',label: 'Οικονομικοί λόγοι' },
  { key: 'other',            label: 'Άλλο' },
];

export const CANCEL_TAGS_DISAGREE: CancelTag[] = [
  { key: 'fulfilled_obligation', label: 'Εκπλήρωσα την υποχρέωσή μου' },
  { key: 'no_violation',         label: 'Δεν υπήρξε παραβίαση' },
  { key: 'unjustified',          label: 'Αδικαιολόγητη αίτηση' },
  { key: 'willing_to_continue',  label: 'Επιθυμώ συνέχιση' },
  { key: 'other',                label: 'Άλλο' },
];

const ALL_TAGS: CancelTag[] = [
  ...CANCEL_TAGS_REQUESTER,
  ...CANCEL_TAGS_AGREE,
  ...CANCEL_TAGS_DISAGREE,
];

export function cancelTagLabel(key: string): string {
  return ALL_TAGS.find((t) => t.key === key)?.label ?? key;
}
